import { createMuiTheme } from '@material-ui/core/styles'
import colors from '../helpers/color.helper'

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },
  typography: {
    useNextVariants: true,
    fontFamily: '\'Inter UI\'',
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 0.3,
    color: '#373737'
  },
  palette: {
    background: {
      default: colors.white
    },
    primary: {
      main: colors.blue
    },
    secondary: {
      main: colors.black,
      contrastText: colors.white
    },
    error: {
      main: colors.error
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  },
  overrides: {
    MuiTypography: {
      h5: {
        fontSize: 22,
        lineHeight: '28px',
        fontWeight: 600,
        color: colors.blue,
        marginBottom: 8
      },
      subtitle1: {
        fontSize: 16,
        fontWeight: 'bold',
        color: colors.black,
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 1.44,
        letterSpacing: 'normal',
        marginBottom: 8
      },
      h6: {
        fontSize: 20,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: 1,
        color: colors.black
      },
      body2: {
        fontSize: 14,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: 0.5
      },
      body1: {
        fontSize: 15,
        lineHeight: '22px',
        color: colors.grey
      }
    },
    MuiInputBase: {
      root: {
        width: 224
      }
    },
    MuiInput: {
      input: {
        border: `1px solid ${colors.blue}`,
        padding: '14px 48px 14px 20px',
        backgroundColor: colors.white,
        borderRadius: 22,
        '&:focus': {
          boxShadow: `0 0 0 1px ${colors.blue}`,
          '&:required': {
            boxShadow: `0 0 0 1px ${colors.blue}`,
            border: `1px solid ${colors.blue}`,
            '&:invalid': {
              boxShadow: `0 0 0 1px ${colors.error}`,
              border: `1px solid ${colors.error}`
            }
          },
          '&:after': {
            borderBottom: 'none'
          }
        },
        '&:disabled': {
          border: `1px solid ${colors.check} !important`,
          color: `${colors.check} !important`
        },
        fontSize: 14,
        fontWeight: 500,
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: 0.3,
        color: colors.black
      },
      underline: {
        '&:after': {
          borderBottom: 'none'
        },
        '&:before': {
          borderBottom: 'none'
        },
        '&&&&:hover:before': {
          borderBottom: 'none'
        },
        '&&&&:before': {
          borderBottom: 'none'
        }
      },
      multiline: {
        border: 'solid 1px #ccc !important',
        padding: '10px 10px',
        backgroundColor: '#fff',
        marginTop: 20
      },
      inputType: {
        height: 'inherit'
      }
    },
    MuiInputAdornment: {
      positionEnd: {
        position: 'absolute',
        right: 20
      }
    },
    MuiCardActions: {
      root: {
        justifyContent: 'flex-end'
      }
    },
    MuiButton: {
      // Name of the styleSheet
      root: {
        height: 44,
        minWidth: 154,
        textTransform: 'none',
        borderRadius: 0
      },
      flat: {
        textAlign: 'center'
      },
      flatPrimary: {
        color: colors.blue
      },
      raisedSecondary: {
        // Name of the rule
        backgroundColor: colors.blue,
        border: 0,
        color: colors.white,
        boxShadow: 'none'
      },
      flatSecondary: {
        color: colors.black
      },
      contained: {
        fontWeight: 600
      },
      containedPrimary: {
        '&:hover': {
          backgroundColor: colors.blue
        },
        '&:disabled': {
          backgroundColor: `${colors.disabled} !important`,
          color: `${colors.white} !important`
        },
        backgroundColor: colors.blue,
        border: 0,
        color: colors.white,
        boxShadow: 'none'
      }
    },
    MuiTabs: {
      indicator: {
        backgroundColor: `${colors.blue}`,
        height: 3
      }
    },
    MuiFormControl: {
      marginNormal: {
        marginTop: 10,
        marginBottom: 10
      }
    },
    MuiInputLabel: {
      formControl: {
        top: -28
      }
    }

  }
})
export default theme
